import BlackFridayBanner from './BlackFridayBanner';
import ColectaLoggiBanner from './ColectaLoggiBanner';
import CyberMondayBanner from './CyberMondayBanner';
import CyberMondayRateBanner from './CyberMondayRateBanner';

function NuvemEnvioBanners() {
  return (
    <>
      <CyberMondayBanner />
      <BlackFridayBanner />
      <ColectaLoggiBanner />
      <CyberMondayRateBanner />
    </>
  );
}

export default NuvemEnvioBanners;
